module.exports = __webpack_public_path__ + "img/06.b1c27964.jpg";